import PropTypes from 'prop-types';

import { useServices } from '@/services/useServices';
import CarouselDesktop from '@/components/layout/carousel/CarouselDesktop';
import CarouselMobile from '@/components/layout/carousel/CarouselMobile';

import styles from './Carousel.module.scss';

export const Carousel = ({ isMobileDevice, slides, isMobile }) => {
  const { datalayerService } = useServices();

  const onClickSlide = (content, position) => {
    datalayerService.pushPromotionClick(content.directory, content.alt, 'ContentCarousel', position);
  };

  const showMobile = isMobile ?? isMobileDevice;

  return slides?.length > 0 ? (
    <div className={styles['millesima-header-carousel']} data-test-id="carousel">
      {showMobile ? (
        <CarouselMobile slides={slides} onClickSlide={onClickSlide} />
      ) : (
        <CarouselDesktop slides={slides} onClickSlide={onClickSlide} />
      )}
    </div>
  ) : null;
};

Carousel.propTypes = {
  slides: PropTypes.array,
  isMobileDevice: PropTypes.bool
};

export default Carousel;
